import { SVGProps } from '@components/Icon/types';

export const FilterList = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 3)">
      <path
        d="M16.1465 12.6465C16.3417 12.4512 16.6583 12.4512 16.8535 12.6465C17.0487 12.8418 17.0487 13.1583 16.8535 13.3535L16.207 14L16.8535 14.6465C17.0487 14.8418 17.0487 15.1583 16.8535 15.3535C16.6583 15.5487 16.3417 15.5487 16.1465 15.3535L15.5 14.707L14.8535 15.3535C14.6583 15.5487 14.3417 15.5487 14.1465 15.3535C13.9512 15.1583 13.9512 14.8417 14.1465 14.6465L14.793 14L14.1465 13.3535C13.9512 13.1583 13.9512 12.8417 14.1465 12.6465C14.3417 12.4512 14.6583 12.4512 14.8535 12.6465L15.5 13.293L16.1465 12.6465Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10C18.2091 10 20 11.7909 20 14C20 16.14 18.3194 17.8879 16.2061 17.9951L16 18H4C1.79086 18 0 16.2091 0 14C0 11.7909 1.79086 10 4 10H16ZM4 11.4004C2.56406 11.4004 1.40039 12.5641 1.40039 14C1.40039 15.4359 2.56406 16.5996 4 16.5996H16C17.4359 16.5996 18.5996 15.4359 18.5996 14C18.5996 12.5641 17.4359 11.4004 16 11.4004H4Z"
        fill={fill}
      />
      <path
        d="M16.1465 2.64648C16.3417 2.45122 16.6583 2.45122 16.8535 2.64648C17.0487 2.84175 17.0488 3.15827 16.8535 3.35352L16.207 4L16.8535 4.64648C17.0487 4.84175 17.0488 5.15827 16.8535 5.35352C16.6583 5.54873 16.3417 5.54872 16.1465 5.35352L15.5 4.70703L14.8535 5.35352C14.6583 5.54873 14.3417 5.54872 14.1465 5.35352C13.9512 5.15826 13.9513 4.84175 14.1465 4.64648L14.793 4L14.1465 3.35352C13.9512 3.15826 13.9513 2.84175 14.1465 2.64648C14.3417 2.45122 14.6583 2.45122 14.8535 2.64648L15.5 3.29297L16.1465 2.64648Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0C18.2091 0 20 1.79086 20 4C20 6.14004 18.3194 7.88789 16.2061 7.99512L16 8H4C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 3.22133e-08 4 0H16ZM4 1.40039C2.56406 1.40039 1.40039 2.56406 1.40039 4C1.40039 5.43594 2.56406 6.59961 4 6.59961H16C17.4359 6.59961 18.5996 5.43594 18.5996 4C18.5996 2.56406 17.4359 1.40039 16 1.40039H4Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'filter-list';
